import DOMPurify from 'dompurify'
import validator from 'validator'

// Sanitize HTML input to prevent XSS attacks
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input
  return DOMPurify.sanitize(input, { ALLOWED_TAGS: [] })
}

// Validate email format
export const validateEmail = (email) => {
  return validator.isEmail(email)
}

// Validate phone number (basic North American format)
export const validatePhone = (phone) => {
  return validator.isMobilePhone(phone, ['en-CA'])
}

// Generate CSRF token (in production, get from server)
export const generateCSRFToken = () => {
  return Array.from(crypto.getRandomValues(new Uint8Array(32)))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

// Store CSRF token in session storage
export const setCSRFToken = () => {
  if (!sessionStorage.getItem('csrfToken')) {
    sessionStorage.setItem('csrfToken', generateCSRFToken())
  }
}

// Get CSRF token
export const getCSRFToken = () => {
  return sessionStorage.getItem('csrfToken') || generateCSRFToken()
}

// Validate form data
export const validateFormData = (data, rules) => {
  const errors = {}

  for (const [field, rule] of Object.entries(rules)) {
    const value = data[field]

    if (rule.required && !value) {
      errors[field] = `${rule.label || field} is required`
      continue
    }

    if (value) {
      if (rule.type === 'email' && !validateEmail(value)) {
        errors[field] = 'Invalid email address'
      }

      if (rule.type === 'phone' && !validatePhone(value)) {
        errors[field] = 'Invalid phone number'
      }

      if (rule.minLength && value.length < rule.minLength) {
        errors[field] = `${rule.label || field} must be at least ${rule.minLength} characters`
      }

      if (rule.maxLength && value.length > rule.maxLength) {
        errors[field] = `${rule.label || field} must not exceed ${rule.maxLength} characters`
      }

      if (rule.pattern && !rule.pattern.test(value)) {
        errors[field] = rule.patternMessage || `${rule.label || field} format is invalid`
      }
    }
  }

  return errors
}
